import { atom, WritableAtom } from 'jotai';

// Type definitions for drag state
export type DraggedItem = {
  directory: string[];
  key: string;
  type: string;
};

// Main atom for tracking which item is being dragged
export const draggedItemAtom = atom<DraggedItem | null>(null) as WritableAtom<
  DraggedItem | null,
  [DraggedItem | null],
  void
>;

// Derived atom to check if any item is currently being dragged
export const isDraggingAtom = atom((get) => get(draggedItemAtom) !== null);
